import { AddOrgFunctionRequestSchema, AddOrgFunctionResponseSchema } from './add-org-function.schema';
/**
 * Add OrgFunction Endpoint Contract
 * Creates a new OrgFunction (team or role) in the organization
 */ export const addOrgFunctionContract = {
    method: 'POST',
    path: '/api/v2/org-function',
    description: 'Create a new OrgFunction in the organization',
    requestSchema: AddOrgFunctionRequestSchema,
    responseSchema: AddOrgFunctionResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=add-org-function.contract.js.map